import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LibraryList from '../../../../components/LibraryList';
import LibraryAside from '../../../../components/LibraryAside';
import CourseDetails from '../../../../components/CourseDetails';

class Details extends Component {
  constructor (props) {
    super(props);
    this.state = {
      shouldRedirect: false
    };
  }

  componentDidMount () {
    this.setState(
      {
        shouldRedirect: false
      }
    );
  }

  componentDidUpdate () {
    if (this.state.shouldRedirect) {
      this.setState(
        {
          shouldRedirect: false
        }
      );
    }
  }

  render () {
    const matchPath = '/courses';
    if (this.state.shouldRedirect) {
      return (
        <Redirect to={matchPath} />
      );
    } else {
      return (
        <main className='main'>
          <Helmet>
            <title>British Sign Language Training and Qualification Courses Library - BSL Courses</title>
            <meta name='description' content='Choose from a range of online British Sign Language training course levels and learn with the help of your own personal one-to-one professional BSL teacher' />
          </Helmet>
          <div className='l-container l-2-col'>
            <div className='secondary'>
              <LibraryList courses={this.props.courses} courseType={this.props.courseType} />
              <LibraryAside />
            </div>
            <Switch>
              <Route
                exact
                path={`${matchPath}/:slug`}
                render={({match}) => {
                  const course = this.props.courses.find(
                    (c) => c.slug === match.params.slug
                  );
                  if (course !== null && course !== undefined) {
                    return <CourseDetails course={course} />;
                  } else {
                    return <Redirect to='/error404' />;
                  }
                }}
              />
              <Route
                exact
                path={matchPath}
                render={({match}) => {
                  const courses = this.props.courses.filter(
                    (c) => c.type === this.props.courseType
                  );
                  if (courses != null && courses.length > 0) {
                    return <CourseDetails course={courses[0]} />;
                  } else {
                    return null;
                  }
                }}
              />
            </Switch>
          </div>
        </main>
      );
    }
  }
}

Details.propTypes = {
  courses: PropTypes.array,
  courseType: PropTypes.string
};

export default Details;



// WEBPACK FOOTER //
// ./src/views/Main/Courses/Details/index.js